import React from 'react';
import { Tappable } from '@vectord/components';

function BulkUpdateSyncButton({ handleOnSync }: IBulkUpdateSyncButton) {
  return (
    <Tappable
      className="primary h5 m-l-m"
      noHighlight
      onClick={handleOnSync}
    >
      Sync Updates
    </Tappable>
  );
}

export default BulkUpdateSyncButton;
